<template>
  <div class="bg-inky-depths-950 text-wave-crest-50 overflow-x-hidden">
    <MarketingHeader class="top-0 w-full z-50 fixed" />
    <div class="py-16">
      <slot />
    </div>
    <MarketingFooter class="bottom-0 w-full fixed" />
  </div>
</template>

<script setup lang="ts">
// NOTE: this is a hack to fix the issue where navigation between some routes causes the bug with the footer appearing above the slot.
// for example, logging out, then navigating the marketing site caused the bug. This is a temporary fix until the root cause is found.
const route = useRoute()
watch(
  () => route.name,
  (newVal, oldVal) => {
    if (oldVal === 'dashboard' && newVal === 'login') {
      location.reload()
    }
  }
)
</script>
